<div class="h-full flex flex-column">
    <header class="flex-grow-0">
        <app-header></app-header>
    </header>
    <main class="flex overflow-hidden h-full relative">
        @if (!!appService.selectedClient) {
        <div id="side-menu" class="overflow-y-auto overflow-x-hidden no-scrollbars" [ngClass]="menuWidthClass">
            <app-side-menu></app-side-menu>
        </div>
        }
        <div id="main-content" class="flex flex-column h-full main-shadow surface-50"
            [class.with-assistant-panel]="assistantPanelService.visible && !assistantPanelService.drawer">
            <div class="flex flex-column flex-1 overflow-hidden min-h-0">
                <!-- Haut de la page -->
                <div class="flex align-items-center justify-content-between flex-shrink-0">
                    <!-- Fil d'arianne -->
                    <div class="flex align-items-end">
                        @if (!!appService.breadcrumbItems.length) {
                        <p-breadcrumb class="flex-grow-0 text-lg" [model]="appService.breadcrumbItems"
                            [home]="appService.homeBreadcrumbItem"></p-breadcrumb>
                        }

                        <!-- Historique de l'objet consulté -->
                        @if (!!appService.historyTarget) {
                        <p-button type="button" icon="pi pi-history" [text]="true" [rounded]="true"
                            pTooltip="Historique" tooltipPosition="bottom" (click)="onClickHistory()"></p-button>
                        }
                    </div>

                    <!-- Aide de l'écran, mention « écrit par l'assistant » (#1217) et messagerie -->
                    <div class="flex align-items-center gap-2 px-5 pt-4">
                        <app-documentation-help-indicator></app-documentation-help-indicator>
                        @if (appService.agentMarkerTarget; as target) {
                        <app-agent-marker [marker]="target.marker" (cleared)="onAgentMarkerCleared()"
                            (undone)="onAgentMarkerUndone()"></app-agent-marker>
                        }
                        <app-conversation-indicator></app-conversation-indicator>
                    </div>
                </div>

                <!-- Contenu de la page (routing) -->
                <div class="flex-grow-1 overflow-hidden p-3">
                    <router-outlet></router-outlet>
                </div>
            </div>

            <!-- Panel des écritures comptables -->
            <div class="flex-shrink-0">
                <app-account-entry-lines-panel></app-account-entry-lines-panel>
            </div>
        </div>

        <!-- Panneau permanent de l'assistant IA (#1292) : dans le shell, hors du router-outlet,
             pour que la conversation et son flux survivent à la navigation -->
        @if (assistantPanelService.visible) {
        <aside id="assistant-panel" class="flex-shrink-0 h-full overflow-hidden"
            [class.drawer]="assistantPanelService.drawer" [class.surface-ground]="assistantPanelService.drawer">
            <app-assistant-workspace mode="panel"></app-assistant-workspace>
        </aside>
        }

    </main>
</div>
<p-blockUI [blocked]="(appService.uiBlocked$ | async) ?? false">
    <p-progressSpinner></p-progressSpinner>
</p-blockUI>